export default __webpack_public_path__ + "static/media/Page3_BG.705c4393.jpg";